module.exports = __webpack_public_path__ + "static/bars1-3627111e74bc567b41673b6f6862e39f.png";